import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk-v2-new';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinct, map } from 'rxjs/operators';
import { ORGANISATIONS, getEntities } from '../../store';

@Pipe({
  name: 'organisationFromId',
  pure: true,
})
export class OrganisationFromIdPipe implements PipeTransform {
  constructor(private store: Store<any>) {}
  public transform(id: string): Observable<OrganisationDto> {
    if (!id || typeof id != 'string') {
      return null;
    }
    return this.store.select(getEntities(ORGANISATIONS)).pipe(
      map(
        (organisationEntities: { [key: string]: OrganisationDto }) =>
          organisationEntities[id] ?? null
      ),
      distinct()
    );
  }
}
